import { FC } from "react";

import { useMatch } from "react-router";
import { Layout } from "./Layout";
import { AuthedLayout } from "./AuthedLayout";
import { useAuthRedirection } from "../auth/hooks/useAuthRedirection";
import { useAppSelector } from "../store";
import { TransitionLayout } from "./TransitionLayout";

export const ProtectedLayout: FC<React.PropsWithChildren<{}>> = () => {
  const user = useAppSelector((state) => state.user);
  const isAuthParentRoute = !!useMatch("/auth");
  const isAuthRoute = !!useMatch("/auth/*") || isAuthParentRoute;

  useAuthRedirection(isAuthRoute);

  return !user.id && !isAuthRoute ? (
    <TransitionLayout />
  ) : isAuthRoute ? (
    <Layout />
  ) : (
    <AuthedLayout />
  );
};
